module.exports = __webpack_public_path__ + "img/main-logo.1e993548.png";